import { render, staticRenderFns } from "./DrawingElementList.vue?vue&type=template&id=a618a18a&scoped=true"
import script from "./DrawingElementList.vue?vue&type=script&lang=js"
export * from "./DrawingElementList.vue?vue&type=script&lang=js"
import style0 from "./DrawingElementList.vue?vue&type=style&index=0&id=a618a18a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a618a18a",
  null
  
)

export default component.exports